import { SvgIcon, SvgIconProps } from '@mui/material'

const SrpTipBaggageIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 32 32">
        <svg fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_6440_54279)">
                <path d="M19.9999 16.6667V16L25.8853 10.1147C26.3854 9.61468 26.6664 8.93651 26.6666 8.22933V5.33333H5.33325V8.30266C5.33325 8.96533 5.57992 9.60533 6.02659 10.096L11.9999 16.6667V28L14.6666 27.1107" stroke="#154588" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M24.6667 29.3333C24.9404 28.2017 25.5208 27.1674 26.3441 26.3441C27.1674 25.5208 28.2017 24.9404 29.3333 24.6667C28.2017 24.3929 27.1674 23.8125 26.3441 22.9892C25.5208 22.1659 24.9404 21.1317 24.6667 20C24.3929 21.1317 23.8125 22.1659 22.9892 22.9892C22.1659 23.8125 21.1317 24.3929 20 24.6667C21.1317 24.9404 22.1659 25.5208 22.9892 26.3441C23.8125 27.1674 24.3929 28.2017 24.6667 29.3333Z" stroke="#FEC524" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
            <defs>
                <clipPath id="clip0_6440_54279">
                    <rect width="32" height="32" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    </SvgIcon>
)

export default SrpTipBaggageIcon
